const hotel = {
  availableMealPlans: "उपलब्ध भोजन योजनाएँ", // translated 
  availableRoomsTypes: "उपलब्ध कमरों के प्रकार", // translated 
  cancellationPolicy: "रद्द करने की नीति", // translated 
  cancellationRules: "रद्द करने के नियम", // translated 
  freeCancellationAvailable: "निःशुल्क रद्द करने की सुविधा उपलब्ध है", // translated 
  nonRefundable: "नॉन रिफंडेबल", // translated 
  priceFor: "कीमत के लिए", // translated 
  nights: "नाइट्स", // translated 
  totalPrice: "कुल कीमत", // translated 
  seeAvailability: "उपलब्धता देखें", // translated 
  myProfile: "मेरी प्रोफाइल", // translated 
  travelTrust: "यात्रा ट्रस्ट", // translated 
  signIn: "दाखिल करना", // translated 
  searchNow: "अब खोजें", // translated 
  policy: "नीति", // translated 
  cxlRules: "CXL नियम", // translated 
  room: "कमरा", // translated 
  cxlPolicy: "सीएक्सएल नीति", // translated 
  beddingType: "बिस्तर का प्रकार", // translated 
  hotelName: "होटल का नाम", // translated 
  reservationDate: "आरक्षण तिथि", // translated 
  maxPax: "मैक्स पैक्स", // translated 
};


export default hotel;
